import Column from 'components/Column';
import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 48px 120px;

  @media (min-width: 801px) and (max-width: 1200px) {
    padding: 48px 60px;
  }
  @media (max-width: 800px) {
    padding: 32px 16px;
  }
`;

export const PageTitleWrapper = styled.div`
  text-align: center;
  margin-bottom: 36px;
`;

export const SectionTitle = styled.h2`
  font-size: 22px;
  ${({ theme }) => theme.fonts.semiBold};
  color: ${({ theme }) => theme.colors.shaft};
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin: 0 0 12px;
`;

export const PageTitleAccent = styled.div`
  width: 48px;
  height: 2px;
  background: ${({ theme }) => theme.colors.gulfStream};
  margin: 0 auto;
`;

export const Block = styled.div`
  display: flex;
  gap: 40px;
  align-items: flex-start;

  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const StyledImage = styled.img<{ $float: string }>`
  width: 42%;
  max-width: 420px;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
  flex-shrink: 0;

  @media (max-width: 800px) {
    width: 100%;
    max-width: 100%;
  }
`;

export const TextsContainer = styled.div`
  flex: 1;
`;

export const Description = styled.p`
  font-size: 16px;
  line-height: 1.75;
  ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.shaft};
  margin: 0;
  overflow-wrap: break-word;
`;

export const GraySection = styled(Column)`
  background: ${({ theme }) => theme.colors.concrete};
  padding: 56px 120px;
  text-align: center;

  @media (min-width: 801px) and (max-width: 1200px) {
    padding: 56px 60px;
  }
  @media (max-width: 800px) {
    padding: 40px 16px;
  }
`;

export const FullImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 8px;
`;
